import { memo, useMemo } from 'react';
import { JsonLd } from 'react-schemaorg';

import { useOptions } from '../hooks/useOptions';
import { usePosts } from '../hooks/usePosts';
import { LiveBlogSchemaOrg, mappingFn } from '../schemaorg';

const LbJsonLdContainer = () => {
  const { posts } = usePosts();
  const options = useOptions();

  const matchDate = new Date(options?.date);
  const postsList = useMemo(() => posts.map(mappingFn(options)).filter(Boolean), [options, posts]);

  return <JsonLd item={LiveBlogSchemaOrg({ options, matchDate, updates: postsList })} />;
};

export default memo(LbJsonLdContainer);
